<h2 align="center">LE 100 TESI: 2008-2017</h2>
<p>Tra le attività della De Cifris troviamo l'organizzazione
	di iniziative divulgative, volte al community building. </p>
<p> Una di queste attività è la raccolta in un volume di
	100 tesi di Crittografia (e argomenti correlati) realizzate
	tra il 2008 e il 2017. </p>
<i> Per visionarlo <a href="http://www.aracne-editrice.it/aracneweb/index
		.php/pubblicazione.html?item=9788825527520"> clicca qui</a></i>
<p>Qui di seguito forniamo una descrizione trasparente dell'attività svolta: </p>
<ul>
	<li>
		<h3>TITOLO</h3>
		<p>100 tesi di Crittografia e Codici in Italia 2008-2017</p>
	</li>
	<li>
		<h3>ORGANIZZATORI</h3>
		<ul>
			<li>Prof. Nadir Murru - <i>nadir.murru&#64;unitn.it</i>;</li>
			<li>Prof. Daniele Bartoli - <i>daniele.bartoli&#64;unipg.it;</i></li>
			<li>Prof. Francesco Pavese - <i>francesco.pavese&#64;poliba.it;</i></li>
		</ul>
		<br>
	</li>
	<li>
		<h3> DESCRIZIONE</h3>
		<p>
			Il volume contiene un breve riassunto in italiano di 100 tesi dal 2008 al
			2017, dando enfasi chiaramente alla <b>crittografia</b>, ma lasciando anche
			spazio ad argomenti collegati, in particolare alla <b>teoria dei codici</b>.
			<br> Per ogni tesi pubblicata, viene allegata una breve presentazione dell'
			autore e un riassunto dei risultati del lavoro svolto, per un totale di:
		</p>
		<ul>
			<li> 3 pagine per tesi triennali o magistrali;</li>
			<li> 5 pagine per tesi di dottorato;</li>
		</ul>
		<p>Il volume è inoltre corredato da articoli di inquadramento dei lavori,
			scritti da membri accademici della De Cifris.</p>
	</li>
	<li>
		<h3>FASI DI REDAZIONE DEL VOLUME</h3>
		<ul>
			<li>
				<b>Richiesta disponibilità dei docenti</b>
				<p>Si richiese ai docenti aderenti alla De Cifris la disponibilità a
					partecipare all'iniziativa.</p>
			</li>
			<li>
				<b>Richiesta disponibilità dei laureati </b>
				<p>I docenti aderenti contattarono gli studenti laureatisi con una tesi nell'ambito della
					crittografia o della teoria dei codici (o argomenti correlati), allegando
					<a href="../../../assets/attivita/100Tesi/documento-100tesi-stud1.pdf"> il seguente documento</a>.
				</p>
			</li>
			<li>
				<b>Gli ex-studenti ottengono maggiori informazioni </b>
				<p>Si fornirono agli ex-studenti interessati le informazioni necessarie
					alla scrittura del proprio riassunto.</p>
			</li>
			<li>
				<b>La selezione delle 100 tesi</b>
				<p>Gli organizzatori selezionarono le 100 migliori tesi ricevute.</p>
			</li>
			<li>
				<b> I contributi accademici </b>
				<p>In base agli argomenti contenuti nelle tesi, vennero individuati alcuni
					membri accademici della De Cifris, i quali prepararono dei contributi
					introduttivi riassuntivi. I docenti in questione furono: Marco Baldi,
					Gabor Korchmaros, Daniele Venturi, Andrea Visconti.</p>
			</li>
			<li>
				<b> Stesura finale</b><br>
				<p>Grazie al lavoro svolto dagli accademici, gli organizzatori coordinarono
					gli ex-studenti nella stesura finale dei riassunti delle tesi.</p>
				<p>Link al libro <a href="http://www.aracne-editrice.it/aracneweb/index.php/
						pubblicazione.html?item=9788825527520">qui</a>.</p>
			</li>
		</ul>
	</li>
</ul>